module.exports = __webpack_public_path__ + "img/20210730_121428.f8d666f2.jpg";